export enum StaffManagementPermissions {
  VIEW_STAFF_MANAGEMENT = "view_staff_management",
  CREATE_STAFF_MANAGEMENT = "create_staff_management",
  UPDATE_STAFF_MANAGEMENT = "update_staff_management",
  DELETE_STAFF_MANAGEMENT = "delete_staff_management",
}

export const StaffManagementPermissionsText: Record<
  StaffManagementPermissions,
  string
> = {
  [StaffManagementPermissions.VIEW_STAFF_MANAGEMENT]: "View Staff Management",
  [StaffManagementPermissions.CREATE_STAFF_MANAGEMENT]:
    "Create Staff Management",
  [StaffManagementPermissions.UPDATE_STAFF_MANAGEMENT]:
    "Update Staff Management",
  [StaffManagementPermissions.DELETE_STAFF_MANAGEMENT]:
    "Delete Staff Management",
};
